/* Dorimo müşteri yorumları — assets JSON'unu okuyup ürün sayfasında render eder. */
(function () {
  "use strict";

  var STAR =
    '<svg viewBox="0 0 20 20" aria-hidden="true"><path fill="currentColor" d="M10 1.6l2.47 5.01 5.53.8-4 3.9.94 5.5L10 14.2l-4.94 2.6.94-5.5-4-3.9 5.53-.8z"/></svg>';

  function stars(n) {
    var out = "";
    for (var i = 1; i <= 5; i++) {
      out += '<span class="' + (i <= n ? "" : "is-empty") + '">' + STAR + "</span>";
    }
    return '<span class="dorimo-rev-stars">' + out + "</span>";
  }

  function initials(name) {
    var parts = (name || "").replace(/\*/g, "").trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return "🙂";
    var a = parts[0][0] || "";
    var b = parts.length > 1 ? parts[parts.length - 1][0] || "" : "";
    return (a + b).toUpperCase();
  }

  function esc(s) {
    var d = document.createElement("div");
    d.textContent = s == null ? "" : String(s);
    return d.innerHTML;
  }

  function card(r) {
    var photos = "";
    if (r.photos && r.photos.length) {
      photos =
        '<div class="dorimo-rev-photos">' +
        r.photos
          .map(function (p) {
            return (
              '<img loading="lazy" src="' +
              esc(p.thumb || p.url) +
              '" data-full="' +
              esc(p.url) +
              '" alt="Müşteri fotoğrafı">'
            );
          })
          .join("") +
        "</div>";
    }
    var verified = r.verified
      ? '<span class="dorimo-rev-verified">✓ Doğrulanmış alışveriş</span>'
      : "";
    return (
      '<article class="dorimo-rev-card">' +
      '<div class="dorimo-rev-card__head">' +
      '<div class="dorimo-rev-card__who">' +
      '<span class="dorimo-rev-avatar">' +
      esc(initials(r.author)) +
      "</span>" +
      "<span>" +
      '<span class="dorimo-rev-name">' +
      esc(r.author) +
      "</span>" +
      "<br>" +
      verified +
      "</span>" +
      "</div>" +
      '<span class="dorimo-rev-date">' +
      esc(r.date) +
      "</span>" +
      "</div>" +
      stars(r.rating) +
      (r.comment ? '<p class="dorimo-rev-text">' + esc(r.comment) + "</p>" : "") +
      photos +
      "</article>"
    );
  }

  function summary(data) {
    var total = data.count || (data.reviews || []).length;
    var dist = data.distribution || {};
    var bars = "";
    for (var s = 5; s >= 1; s--) {
      var c = dist[s] || 0;
      var pct = total ? Math.round((c / total) * 100) : 0;
      bars +=
        '<div class="dorimo-rev-bar">' +
        '<span class="dorimo-rev-bar__label">' + s + " " + STAR + "</span>" +
        '<span class="dorimo-rev-bar__track"><span class="dorimo-rev-bar__fill" style="width:' + pct + '%"></span></span>' +
        '<span class="dorimo-rev-bar__pct">' + pct + "%</span>" +
        "</div>";
    }
    return (
      '<div class="dorimo-rev-summary">' +
      '<div class="dorimo-rev-score">' +
      '<div class="dorimo-rev-score__num">' + (data.average || 0).toFixed(1).replace(".", ",") + "</div>" +
      stars(Math.round(data.average || 0)) +
      '<div class="dorimo-rev-score__count">' + total + " değerlendirme</div>" +
      "</div>" +
      '<div class="dorimo-rev-bars">' + bars + "</div>" +
      "</div>"
    );
  }

  function photoStrip(data) {
    var photos = [];
    (data.reviews || []).forEach(function (review) {
      (review.photos || []).forEach(function (photo) {
        photos.push({
          thumb: photo.thumb || photo.url,
          url: photo.url,
          author: review.author || 'Müşteri'
        });
      });
    });

    if (!photos.length) return '';

    return (
      '<section class="dorimo-rev-photo-gallery" aria-label="Fotoğraflı müşteri yorumları">' +
      '<div class="dorimo-rev-photo-gallery__head"><h3>Fotoğraflı Yorumlar</h3><span>' + photos.length + ' fotoğraf</span></div>' +
      '<div class="dorimo-rev-photos dorimo-rev-photos--strip">' +
      photos.slice(0, 16).map(function (photo) {
        return '<img loading="lazy" src="' + esc(photo.thumb) + '" data-full="' + esc(photo.url) + '" alt="' + esc(photo.author) + ' tarafından eklenen müşteri fotoğrafı">';
      }).join('') +
      '</div></section>'
    );
  }

  function lightbox() {
    var el = document.querySelector(".dorimo-rev-lightbox");
    if (el) return el;
    el = document.createElement("div");
    el.className = "dorimo-rev-lightbox";
    el.innerHTML =
      '<button class="dorimo-rev-lightbox__close" aria-label="Kapat">&times;</button><img alt="">';
    document.body.appendChild(el);
    var close = function () {
      el.classList.remove("is-open");
    };
    el.addEventListener("click", function (e) {
      if (e.target === el || e.target.classList.contains("dorimo-rev-lightbox__close")) close();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") close();
    });
    return el;
  }

  function render(root, data) {
    var perPage = parseInt(root.closest("[data-dorimo-reviews]").dataset.perPage, 10) || 8;
    // 1 yıldızlı yorumlar listenin sonunda; diğerlerinin kendi sırası korunur.
    var all = (data.reviews || []).filter(function (r) { return r.rating !== 1; })
      .concat((data.reviews || []).filter(function (r) { return r.rating === 1; }));
    var filter = "all";
    var shown = perPage;

    function current() {
      var list = all;
      if (filter === "photos") list = all.filter(function (r) { return r.photos && r.photos.length; });
      else if (filter !== "all") list = all.filter(function (r) { return r.rating === Number(filter); });
      return list;
    }

    function paint() {
      var list = current();
      var slice = list.slice(0, shown);
      var withPhotos = all.filter(function (r) { return r.photos && r.photos.length; }).length;

      var html = summary(data) + photoStrip(data);

      html +=
        '<div class="dorimo-rev-filters">' +
        chip("all", "Tümü (" + all.length + ")") +
        chip("5", "5 yıldız") +
        chip("4", "4 yıldız") +
        chip("3", "3 yıldız") +
        chip("2", "2 yıldız") +
        chip("1", "1 yıldız") +
        (withPhotos ? chip("photos", "📷 Fotoğraflı (" + withPhotos + ")") : "") +
        "</div>";

      html += '<div class="dorimo-rev-list">' + slice.map(card).join("") + "</div>";

      if (shown < list.length) {
        html +=
          '<div class="dorimo-rev-more"><button class="button button--secondary" data-more>' +
          "Daha fazla yorum (" + (list.length - shown) + ")</button></div>";
      }
      root.innerHTML = html;
    }

    function chip(val, label) {
      return (
        '<button class="dorimo-rev-chip" data-filter="' + val + '" aria-pressed="' +
        (filter === val) + '">' + label + "</button>"
      );
    }

    root.addEventListener("click", function (e) {
      var f = e.target.closest("[data-filter]");
      if (f) {
        filter = f.dataset.filter;
        shown = perPage;
        paint();
        return;
      }
      if (e.target.closest("[data-more]")) {
        shown += perPage;
        paint();
        return;
      }
      var img = e.target.closest(".dorimo-rev-photos img");
      if (img) {
        var lb = lightbox();
        lb.querySelector("img").src = img.dataset.full || img.src;
        lb.classList.add("is-open");
      }
    });

    paint();
  }

  // Ürün başlığı altındaki puan satırını (varsa) gerçek ortalamayla doldur
  function updateRatingSummary(data) {
    var el = document.querySelector("[data-dorimo-rating-summary]");
    if (!el) return;
    var avg = data.average || 0;
    var full = Math.round(avg);
    var starsEl = el.querySelector(".dorimo-pdp-rating__stars");
    var scoreEl = el.querySelector(".dorimo-pdp-rating__score");
    var countEl = el.querySelector(".dorimo-pdp-rating__count");
    if (starsEl) {
      starsEl.textContent = "";
      for (var i = 1; i <= 5; i++) starsEl.textContent += i <= full ? "★" : "☆";
    }
    if (scoreEl) scoreEl.textContent = avg.toFixed(1).replace(".", ",");
    if (countEl) {
      countEl.textContent = (data.count || data.reviews.length) + " değerlendirme";
    }
  }

  function boot(el) {
    var root = el.querySelector("[data-reviews-root]");
    var src = el.dataset.src;
    if (!src) return;
    fetch(src)
      .then(function (r) {
        if (!r.ok) throw new Error("404");
        return r.json();
      })
      .then(function (data) {
        if (!data.reviews || !data.reviews.length) {
          root.innerHTML = '<p class="dorimo-rev-state">Henüz yorum yok.</p>';
          return;
        }
        var sourceUrl = new URL(src, window.location.href);
        data.reviews.forEach(function (review) {
          (review.photos || []).forEach(function (photo) {
            if (!photo.file) return;
            var assetUrl = new URL(photo.file, sourceUrl).href;
            photo.url = assetUrl;
            photo.thumb = assetUrl;
          });
        });
        updateRatingSummary(data);
        render(root, data);
      })
      .catch(function () {
        el.style.display = "none";
      });
  }

  function initAll() {
    document.querySelectorAll("[data-dorimo-reviews]").forEach(function (el) {
      if (el.__dorimoInit) return;
      el.__dorimoInit = true;
      boot(el);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
  // Tema editöründe bölüm eklenince
  document.addEventListener("shopify:section:load", initAll);
})();
